import React from 'react';
import MyFinanceRoutes from '../routes/MyFinanceRoutes';

const MyFinanceLayout = () => <MyFinanceRoutes />

export default MyFinanceLayout;